<script>
import ModalOverlay from '@/components/modal/ModalOverlay';
import Simplebar from 'simplebar-vue';
import { mapActions } from 'vuex';
import { getLeaderboardRowValue } from '@/scripts/methods';
import SvgIcon from '@/components/SvgIcon';

export default {
  name: 'ModalMobileTable',
  components: {
    ModalOverlay,
    Simplebar,
    SvgIcon,
  },
  props: {
    head: {
      required: true,
    },
    body: {
      required: true,
    },
    avatar: {
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    filterHead() {
      const { head } = this;

      return head.filter(
        item => item.caption !== 'Rank' && item.caption !== 'Player'
      );
    },
  },
  created() {},
  mounted() {},
  methods: {
    ...mapActions({
      toggleModalLeaderboardData: 'toggleModalLeaderboardData',
    }),
    getLeaderboardRowValue,
  },
};
</script>

<template>
  <div>
    <ModalOverlay>
      <div class="modal__dialog">
        <div class="modal__content">
          <div class="modal__top">
            <div class="modal__avatar" :style="avatar">
              <div class="modal__flag">
                <SvgIcon
                  :name="
                    getLeaderboardRowValue(body, '_player', {
                      subField: 'country',
                    })
                  "
                ></SvgIcon>
              </div>
            </div>
            <div class="modal__info">
              <div
                :class="{
                  modal__rank: true,
                  'modal__rank--main':
                    getLeaderboardRowValue(body, '_rank') === '1',
                }"
              >
                {{ getLeaderboardRowValue(body, '_rank') }}
              </div>
              <div class="modal__name">
                {{ getLeaderboardRowValue(body, '_player') }}
              </div>
            </div>
            <div class="modal__close" @click="toggleModalLeaderboardData()">
              <img :src="require('@/assets/svg/close.svg')" />
            </div>
          </div>
          <div class="modal__middle">
            <Simplebar data-simplebar-auto-hide="false" class="scroll">
              <div class="modal__wrapper">
                <div
                  class="modal__item"
                  v-for="{ statsField, caption } in filterHead"
                  :key="statsField"
                >
                  <div class="modal__label">{{ caption }}</div>
                  <div class="modal__value">
                    {{ getLeaderboardRowValue(body, statsField) }}
                  </div>
                </div>
              </div>
            </Simplebar>
          </div>
        </div>
      </div>
    </ModalOverlay>
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.modal {
  &__dialog {
    padding: 72px 0px 0px;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: center;
  }

  &__content {
    max-width: 970px;
    max-height: 100%;
    border-top-left-radius: 36px;
    border-top-right-radius: 36px;
    background-color: #232e33;
    padding: 40px 15px 0;
    display: flex;
    flex-direction: column;
    width: 100%;
    color: #ffffff;
  }

  &__top {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    padding-bottom: 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  }

  &__avatar {
    position: relative;
    width: 64px;
    height: 64px;
    border-radius: 15.4px;
    box-shadow: 0 5px 21px 0 rgba(0, 0, 0, 0.5);
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
  }

  &__flag {
    position: absolute;
    bottom: -1px;
    right: -4px;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;

    .svg-icon {
      width: 100%;
      height: 100%;
      position: relative;
      -webkit-transform: scale(1.4);
      transform: scale(1.4);
    }
  }

  &__info {
    margin-left: 15px;
  }

  &__rank {
    font-family: Poppins-SemiBold;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 1.17px;
    color: #ffffff;

    &--main {
      color: #ffc107;
    }
  }

  &__name {
    font-family: Poppins-Regular;
    font-size: 18px;
    line-height: 25px;
    color: #ffffff;
    margin-top: 4px;
  }

  &__middle {
    flex-grow: 1;
    display: flex;
    overflow: hidden;
    padding: 24px 0 38px;

    .scroll {
      flex-grow: 1;
    }
  }

  &__close {
    position: fixed;
    right: 20px;
    top: 20px;
    width: 18px;
    height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
    cursor: pointer;

    img {
      display: flex;
      width: 100%;
      height: 100%;
    }

    &:hover {
      opacity: 0.5;
    }
  }

  &__wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  &__item {
    width: 50%;
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    &:nth-child(even) {
      padding-left: 30px;
    }

    &:nth-child(1),
    &:nth-child(2) {
      margin-top: 10px;
    }
  }

  &__label {
    font-family: Poppins-Regular;
    font-size: 12px;
    line-height: 17px;
    color: rgba(255, 255, 255, 0.4);
    margin-bottom: 10px;
  }

  &__value {
    font-family: Poppins-Light;
    font-size: 18px;
    line-height: 25px;
    letter-spacing: 0.38px;
    color: #ffffff;
    word-break: break-all;
  }
}
</style>
